import React, { Suspense } from 'react';
import Layout from '@/components/layout';
import Loading from '@/components/loading';

const FirstPage = React.lazy(() => import('../views/firstPage'));
const DocViewer = React.lazy(() => import('../views/docViewer'));
const ContactUs = React.lazy(() => import('../views/contactUs'));
const Admin = React.lazy(() => import('../views/admin'));


const lazyComponent = function (Component) {
  return (
    <Layout>
      <Suspense fallback={<Loading />}>
        <Component />
      </Suspense>
    </Layout>
  );
};

const routeList = [
  {
    name: 'home',
    path: '/home',
    component: () => lazyComponent(FirstPage),
    exact: true
  },
  {
    name: 'connectPlan',
    path: '/connect-plan',
    component: () => lazyComponent(DocViewer),
    exact: true
  },
  {
    name: 'contactUs',
    path: '/contact-us',
    component: () => lazyComponent(ContactUs),
    exact: true
  },
  {
    name: 'admin',
    path: '/admin',
    component: () => lazyComponent(Admin)
  },
];

export default routeList;